export const UPDATE_QUOTE_MODAL_CHARGES = "UPDATE_QUOTE_MODAL_CHARGES";
export const ADD_QUOTE_MODAL_CHARGES = "ADD_QUOTE_MODAL_CHARGES";
export const REMOVE_QUOTE_MODAL_CHARGES = "REMOVE_QUOTE_MODAL_CHARGES";
export const BLANK_MODAL_CHARGE = "BLANK_MODAL_CHARGE";
export const GET_CURRENCY_EXCHANGE_RATE = "GET_CURRENCY_EXCHANGE_RATE";
export const GET_CURRENCY_EXCHANGE_RATE_SUCCESS = "GET_CURRENCY_EXCHANGE_RATE_SUCCESS";